<template>
  <a
    v-if="hasViewMore"
    href="#"
    class="btn-more all"
    @click.prevent="onClickViewMore()"
    >{{ viewMoreTitle(DEFAULT_VIEW_MORE_TITLE) }}</a
  >
</template>
<script setup>
  import { defineProps } from 'vue'
  import { useViewMore } from '@/common/use/useViewMore'
  const DEFAULT_VIEW_MORE_TITLE = '더보기'

  const props = defineProps({
    sectionInfo: {
      type: Object,
      default: () => {},
    },
  })

  const { onClickViewMore, viewMoreTitle, hasViewMore } = useViewMore(
    props.sectionInfo,
  )
</script>
